import { Stack, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useGetAuthenticatedUserUserGetQuery } from "api";
import { ErrorPage, LoadingPage, NoDataPage } from "components/pages";
import { ZoneUserRole } from "constants/userContstants";

import { UserAuth } from "./components/UserAuth";
import { UserForm } from "./components/UserForm";
import { UserPreference } from "./components/UserPreference";

export const UserProfileScreen = () => {
  const { t } = useTranslation();

  const {
    data: userData,
    isLoading,
    isError,
    refetch,
  } = useGetAuthenticatedUserUserGetQuery();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isError) {
    return (
      <ErrorPage
        title={"Failed to load user"}
        buttonText={t("Try again")}
        buttonOnClick={refetch}
      />
    );
  }

  const user = userData?.data;

  if (!user) {
    return <NoDataPage title={"User not found"} message={""} />;
  }

  const roles = user.roles ?? [];

  return (
    <Stack sx={{ gap: 2, padding: 2 }}>
      <Typography
        variant={"headingLargeRegular"}
        sx={{
          paddingInline: 2,
        }}
      >
        {t("employee_profile")}
      </Typography>
      {!(roles.length === 1 && roles[0] === ZoneUserRole.SERVICE_MONITOR) && (
        <>
          <UserForm user={user} />
          <UserAuth />
        </>
      )}
      <UserPreference preferences={user.preferences} />
    </Stack>
  );
};
